export const selectIsSMSEnabled  = state => {
  return state.OrganisationReducer.customerData.isSMSEnabled;
}

export const getUserNotifySetting = state => {
  return state.OrganisationReducer.customerData.userNotifySetting;
}

export const getUserInventMsgCustomize  = state => {
  return state.OrganisationReducer.customerData.userInventMsgCustomize;
}

export const getIsEntryAllowed = state => {
  return state.OrganisationReducer.customerData.isEntryAllowed;
}

export const getIconLarge = state => {
  return state.OrganisationReducer.customerData.iconLarge;
}

export const getIsReductionLogs  = state => {
  return state.OrganisationReducer.customerData.isReductionLogs
}

export const getHorizontalDisplayFixed = state => {
  return state.OrganisationReducer.customerData.horizontalDisplayFixed;
}

export const getDisableCanvasEdit = state => {
  return state.OrganisationReducer.customerData.disableCanvasEdit;
}

export const getDisableIcsFile = state => {
  return state.OrganisationReducer.customerData.disableIcsFile;
}

export const getCustomerName = state => {
  return state.OrganisationReducer.customerData.name;
}

export const getWording = state => {
  return state.OrganisationReducer.customerData.wording;
}

export const getTranslation = state => {
  return state.OrganisationReducer.customerData.translation;
}

export const getEnableVideoBlur = state => {
  return state.OrganisationReducer.customerData.enableVideoBlur;
}
